import React from 'react';
import Button from 'react-bootstrap/Button';
import { FaDownload  } from "react-icons/fa";
import ReactExport from 'react-export-excel';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;

const SpeedReportXls = (props) => {


    const headerStyle = {fill: {patternType: "solid", fgColor: {rgb: "FFD364"}},}; //a6c4e4
    const headerStyle2 = {font: {bold: true, color: {rgb: "000000"}},};

    const asset = props.asset && props.asset.replace('&','and')
    const WEEKDAY = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat']

    let speedTime = props.speedTime.map(item => [item.date, item.speed])
    let speedV85 = props.speedV85.map(item => [item.date, item.speed]);
    let maxSpeed = props.maxSpeed.map(item => [item.date, item.speed]);
    let avgSpeedWeekday = props.avgSpeedWeekday.map(item => [WEEKDAY[item.date], item.speed]);
    let vehicleCount = props.vehicleCount.map(item => [item.date, item.count]);
    let adt = props.adt.map(item => [item.date, item.count]);
    let vehClass = props.vehClass

    const headSpeedTime = [
        [
            {value: "Date", style: headerStyle},
            {value: "Avg Speed", style: headerStyle},
        ],
    ]   

    const headSpeedV85 = [
        [
            {value: "Date", style: headerStyle},
            {value: "Percentil 85", style: headerStyle},
        ],
    ]  

    const headMaxSpeed = [
        [
            {value: "Date", style: headerStyle},
            {value: "Max Speed", style: headerStyle},
        ],
    ] 

    const headCounts = [
        [
            {value: "Date", style: headerStyle},
            {value: "Total Vehicles", style: headerStyle},
        ],
    ]  

    const headAvgCounts = [
        [
            {value: "Date", style: headerStyle},
            {value: "Avg Vehicles", style: headerStyle},
        ],
    ]  

    let dateFrom = ""
    if (props.dateFrom){
        const d = new Date(props.dateFrom);
        dateFrom = ("0"+d.getDate()).slice(-2) + "-" + ("0"+(d.getMonth()+1)).slice(-2) + "-" + d.getFullYear();
    }
    let dateTo = ""
    if (props.dateTo){
        const d = new Date(props.dateTo);
        dateTo = ("0"+d.getDate()).slice(-2) + "-" + ("0"+(d.getMonth()+1)).slice(-2) + "-" + d.getFullYear();
    }

    const dt = "Date From:" + dateFrom +" to: "+ dateTo

    const dataSet = [
        {   columns: [asset + " - Speed Report", dt],
            data: [ 
            [{value:"Class: "+ vehClass, style: headerStyle2}],"",
            [{value:"Speed v Time", style: headerStyle2}],...headSpeedTime,...speedTime, "",
            [{value:"Speed V85", style: headerStyle2}],...headSpeedV85, ...speedV85,"",
            [{value:"Max Speed", style: headerStyle2}],...headMaxSpeed, ...maxSpeed,"",
            [{value: "Speed v Weekday" , style: headerStyle2}],...headSpeedTime,...avgSpeedWeekday,"",
            [{value: "Records vs time" , style: headerStyle2}],...headCounts,...vehicleCount,"",
            [{value: "Average Daily Traffic (ADT)" , style: headerStyle2}],...headAvgCounts,...adt,"",
                ],
        },
    ]

        return (
            <div>
                <ExcelFile filename={asset + " - Speed Report"} element={<Button size="sm" variant="light"><FaDownload />&nbsp; Download </Button>}>
					<ExcelSheet dataSet={dataSet} name={asset} />
				</ExcelFile>
            </div>
        );
}


export default SpeedReportXls;


